import {
    EBON_USER_STATE_UNKNOWN,
    EBON_USER_STATE_CURRENTLY_IN_USE,
    EBON_USER_STATE_PENDING,
    EBON_USER_STATE_USED,
    EBON_USER_STATE_VALIDATED,
    EBON_USER_STATES_IN_PROGRESS,
    EBON_USER_STATES_CONSUMED
} from '../constants/ebon';

export const formatAmountWithComma = (amount) => {
    if (amount === null || amount === undefined) return '';
    return parseFloat(amount).toFixed(2).replace('.', ',');
};

export const parseAmountFromComma = (amountString) => {
    if (!amountString) return 0;
    return parseFloat(amountString.replace(',', '.'));
};

export const calculateTotalRemainingBalance = (ebonList) => {
    if (!ebonList || ebonList.length === 0) return 0;

    const total = ebonList.reduce((sum, ebon) => {
        const remaining = ebon.remainingBalance !== undefined && ebon.remainingBalance !== null
            ? parseFloat(ebon.remainingBalance)
            : 0;
        return sum + remaining;
    }, 0);

    return total;
};

export const getOrderStatus = (ebonList, totalAmount) => {
    if (!ebonList || ebonList.length === 0) {
        return {
            status: EBON_USER_STATE_UNKNOWN,
            remainingBalance: null
        };
    }

    const allConsumed = ebonList.every(ebon =>
        EBON_USER_STATES_CONSUMED.includes(ebon.userState)
    );

    if (allConsumed) {
        return {
            status: EBON_USER_STATE_USED,
            remainingBalance: null
        };
    }

    const someConsumedOrInProgress = ebonList.some(ebon =>
        EBON_USER_STATES_CONSUMED.includes(ebon.userState) ||
        ebon.userState === EBON_USER_STATE_CURRENTLY_IN_USE ||
        ebon.userState === EBON_USER_STATE_PENDING
    );

    if (someConsumedOrInProgress) {
        const totalRemaining = totalAmount - calculateTotalRemainingBalance(ebonList);
        const showAmount = totalRemaining < totalAmount;

        return {
            status: EBON_USER_STATE_CURRENTLY_IN_USE,
            remainingBalance: showAmount ? (isNaN(totalRemaining) ? 0 : totalRemaining) : totalAmount
        };
    }

    return {
        status: EBON_USER_STATE_UNKNOWN,
        remainingBalance: null
    };
};

export const isOrderInProgress = (ebonList) => {
    if (!ebonList || ebonList.length === 0) return true;

    return ebonList.some(ebon =>
        !ebon.userState || EBON_USER_STATES_IN_PROGRESS.includes(ebon.userState)
    );
};

export const isOrderConsumed = (ebonList) => {
    if (!ebonList || ebonList.length === 0) return false;

    return ebonList.every(ebon =>
        EBON_USER_STATES_CONSUMED.includes(ebon.userState)
    );
};

export const buildEbonUserStatePayload = (ebonList, status, balance) => {
    if (!ebonList || ebonList.length === 0) return [];

    return ebonList.map(ebon => ({
        id: ebon.id,
        userState: status,
        remainingBalance: balance
            ? parseAmountFromComma(balance)
            : ebon.facialValue
    }));
};

export const extractOrderId = (id) => {
    if (typeof id === 'string' && id.includes('-')) {
        return id.substring(0, id.indexOf('-'));
    }
    return id;
};

export const getStatusOptions = (i18nPage) => [
    {
        label: i18nPage.STATUS.IN_PROGRESS,
        value: EBON_USER_STATE_CURRENTLY_IN_USE
    },
    {
        label: i18nPage.STATUS.CONSUMED,
        value: EBON_USER_STATE_USED
    },
    {
        label: i18nPage.STATUS.NOT_FILLED,
        value: EBON_USER_STATE_UNKNOWN
    }
];

export const shouldShowBalanceInput = (status) => {
    return status === EBON_USER_STATE_CURRENTLY_IN_USE ||
           status === EBON_USER_STATE_PENDING;
};

export const mapEbonStateToSelectValue = (ebonState) => {
    if (!ebonState) return '';

    if (ebonState === EBON_USER_STATE_PENDING) {
        return EBON_USER_STATE_CURRENTLY_IN_USE;
    }

    if (ebonState === EBON_USER_STATE_VALIDATED) {
        return EBON_USER_STATE_USED;
    }

    if ([EBON_USER_STATE_CURRENTLY_IN_USE, EBON_USER_STATE_USED, EBON_USER_STATE_UNKNOWN].includes(ebonState)) {
        return ebonState;
    }

    return '';
};



// WEBPACK FOOTER //
// ./src/utils/ebonStatusUtils.js